import Api from 'tm3-core/api';

class ClinicalEndpoints {
  onCreate(report) {
    let { caseId } = report;
    let url = `/api/cases/${caseId}/reports`;

    return new Promise((resolve, reject) => {
      Api.post(url, report).then((res) => {
        resolve(res.body.result);
      });
    });
  }

  onUpdate(report) {
    let { id, caseId } = report;
    let url = `/api/cases/${caseId}/reports/${id}`;

    return new Promise((resolve, reject) => {
      Api.put(url, report).then((res) => {
        resolve(res.body.result);
      });
    });
  }

  onSubmit(report) {
    let { id, caseId } = report;
    let url = `/api/cases/${caseId}/reports/${id}/submit`;

    return new Promise((resolve, reject) => {
      Api.post(url, report).then((res) => {
        resolve(res.body.result);
      });
    });
  }

  onAcknowledge(caseId, id) {
    return new Promise((resolve, reject) => {
      Api.post(`/api/cases/${caseId}/reports/${id}/acknowledge`).then(() => {
        resolve();
      });
    });
  }
}

export default new ClinicalEndpoints();
